import type { AnyID, SceneObjects } from '@types'

type LinkedLike = SceneObjects & {
  childs?: Set<AnyID>
  childrenOrder?: string[]
  firstParentID?: AnyID
}

function childIdsFromChildrenOrder(childrenOrder: string[]): AnyID[] {
  return childrenOrder
    .map((entry) => {
      const sep = entry.indexOf('!')
      return (sep >= 0 ? entry.slice(sep + 1) : entry) as AnyID
    })
    .filter(Boolean)
}

/** IDs de hijos de un linkedItem (linkedSons, CORTEKIT, etc.). No incluye rootId. */
export function collectLinkedDescendantIds(
  items: Map<string, SceneObjects>,
  rootId: string,
): Set<AnyID> {
  const descendants = new Set<AnyID>()
  const queue: string[] = [rootId]

  while (queue.length > 0) {
    const currentId = queue.shift()!
    const currentItem = items.get(currentId) as LinkedLike | undefined
    if (!currentItem) continue

    const enqueueChild = (childId: string) => {
      if (childId === rootId || descendants.has(childId as AnyID)) return
      descendants.add(childId as AnyID)
      queue.push(childId)
    }

    currentItem.childs?.forEach((childId) => enqueueChild(childId as string))

    if (currentItem.childrenOrder?.length) {
      childIdsFromChildrenOrder(currentItem.childrenOrder).forEach((childId) =>
        enqueueChild(childId as string),
      )
    }

    items.forEach((candidate, candidateId) => {
      const fp = (candidate as LinkedLike).firstParentID
      if (fp != null && String(fp) === String(currentId)) {
        enqueueChild(candidateId)
      }
    })
  }

  return descendants
}
